import ReactPDF, { Line, StyleSheet } from '@react-pdf/renderer';
import { PDFViewer, Document, Page, Text, View } from '@react-pdf/renderer';
import { Fragment } from 'react';
import ReactPDFChart from "react-pdf-charts";
import { CartesianGrid, Cell, LineChart, Pie, PieChart, Tooltip, XAxis, YAxis } from 'recharts';



  

const colourCellTrue = "rgb(130, 147, 132)";
const colourCellFalse = "white";
const cellWidth = `${100 / 36}%`;
const monthCellWidth = `${100 / 12}%`;
const cellHeight = "100%";
const cellPadding = "0";
  const styles = StyleSheet.create({
      table: {
          width: '100%',
          paddingLeft:20,
          paddingRight:20,
          paddingTop:8,
          paddingBottom:8,
      },
      row: {
          display: 'flex',
          flexDirection: 'row',
          borderTop: '1px solid black',
          // paddingTop: 8,
          // paddingBottom: 8,
      },
      rowNoBorder: {

            display: 'flex',
            flexDirection: 'row',
      },
      header: {
          borderTop: 'none',
      },
      bold: {
          fontWeight: 'bold',
      },
      col1: {
          width: '27%',
      },
      avgCell:{
          width: cellWidth
      },
      monthCell: {
          width: monthCellWidth,
          textAlign: 'center',
      },
      col2: {
          width: '15%',
      },
      col3: {
          width: '15%',
      },
      col4: {
          width: '20%',
      },
      col5: {
          width: '27%',
      },
      cellTrue: {
          
          backgroundColor: colourCellTrue,
          width: cellWidth,
          height: cellHeight,
          padding: cellPadding,
      },
      cellFalse: {
          backgroundColor: colourCellFalse,
          width: cellWidth,
          height: cellHeight,
          padding: cellPadding,
      },
      thirdCell: {
          borderRight: '1px solid black',
      },
      page: {
          // margin: 10,
          padding: 20,

          // flexGrow: 1
        },
      title: {
          fontSize: 24,
          textAlign: 'left',
          marginLeft: 20,
          marginBottom: 12,
      },
      subtitle: {
          fontSize: 18,
          textAlign: 'left',
          marginLeft: 20,
          marginBottom: 12,
      },
      section: {
          margin: 10,
          padding: 10,
          marginBottom: 4,
          paddingBottom:4,
          flexGrow: 1,
      },
      commentTitle:{
          fontSize: 14,
          textAlign: 'left',
          marginLeft: 5,
          marginBottom: 5,
      },
      commentBody:{
          fontSize: 10,
          textAlign: 'left',
          marginLeft: 5,
          marginBottom: 12,
      },
      sectionTitle:{
        fontSize: 16,
          marginBottom: 8,
      },
      soilComp: {
        marginBottom: 4,
      },
      soilGraph: {
        width:"30%"
      },
      soilComments: {
        width: "70%",
        fontSize: 10,
      }
  });

  const numbers = [];
  for (let i = 1; i <= 36; i++) {
    numbers.push(i);
  }
  
  const months = [
    // just first three letters of the month
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({value, label, cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
  
    return (
      <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
        {/* {`${value} x ${label}`} */}
        {value}
      </text>
    );
  };


const StagePage = ({ commonName, scientificName, name, stage, yearlyChartComment, soilComposition =[], soilComment }) => {

    // if stage not passed\
    if (!stage) {
        return null;
    }
    let isFilled = false;
    if (stage){
        stage.forEach((row) => {
          if (row.decans.length > 0){
            isFilled = true;
          }
        });
      }
      if(!isFilled){
        return null;
      }
      

      // geenrate colours based on length of soilComposition
      const COLORS = soilComposition.map((item, index) => {
        // return `rgb(${Math.floor(255 / soilComposition.length) * index}, ${Math.floor(255 / soilComposition.length) * index}, ${Math.floor(255 / soilComposition.length) * index})`;
        // make them shades of green
        // return `rgb(${Math.floor(255 / soilComposition.length) * index}, ${Math.floor(255 / soilComposition.length) * index + 100}, ${Math.floor(255 / soilComposition.length) * index})`;
        //shades of brown
        // return `rgb(${Math.floor(255 / soilComposition.length) * index + 100}, ${Math.floor(255 / soilComposition.length) * index + 50}, ${Math.floor(255 / soilComposition.length) * index})`;
        // Shades of brown but remain under 200
        return `rgb(${Math.floor(200 / soilComposition.length) * index + 50}, ${Math.floor(200 / soilComposition.length) * index + 25}, ${Math.floor(200 / soilComposition.length) * index})`;
      });

      const soilCompInOrderOfValue = soilComposition.sort((a, b) => b.value - a.value);

    return (
        <Page
                orientation='landscape'
                style={styles.page}
                
                >
                    <Text style={styles.title}>{commonName} ({scientificName}) - {name}</Text>
                    <View style={styles.table}>
                        <View style={[styles.row, styles.bold, styles.header]}>
                        <Text key={`1st pad`} style={styles.col1}>
                        </Text>
                            {months.map((month, index) => (
                                <Fragment key={index}>
                                <Text key={month} style={styles.monthCell}>
                                    {month}
                                </Text>
                                </Fragment>
                            ))}
                        </View>
                        {stage.map((row, i) => (
                            
                (row.decans.length > 0 &&
                            <View key={i} style={styles.row} wrap={false}>
                            <Text style={styles.col1}>
                            {row.name}
                            </Text>
                            
                  {numbers.map((number, i) => (
                            <Text
                            key={i}
                            style={[
                                row.decans.includes(number)
                                ? styles.cellTrue
                                : styles.cellFalse,
                                number % 3 === 0 ? styles.thirdCell : null,
                                // if first cell
                                i === 0 ? {borderLeft: '1px solid black'} : null

                            ]
                            }
                            >
                            </Text>
                    ))}
                            </View>
                        )))}
                    </View>
                    

                    
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Yearly Chart</Text>
                        
                        <Text style={styles.commentBody}>
                                {yearlyChartComment}
                            </Text>
                    
                    </View>
                    <View style={styles.rowNoBorder}>
                        <View
                            style={styles.soilGraph}
                        >
                        <ReactPDFChart>
            <PieChart width={250} height={200}>
            <Pie
                dataKey="value"
                isAnimationActive={false}
                data={soilComposition}
                cx="50%"
                cy="50%"
                outerRadius={80}
                fill="#8884d8"
                // label = {({label, value}) => ` ${value} x ${label}`}
                
            labelLine={false}
            label={renderCustomizedLabel}
            >
                {soilComposition.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
                </Pie>
            </PieChart>
        </ReactPDFChart>
                        </View>
                        <View
                            style={styles.soilComments}
                        >
                            <Text style={styles.sectionTitle}>Soil Composition</Text>
                            <View style={styles.soilComp}>
                                {soilCompInOrderOfValue.map((item, index) => (
                                    <Text key={index}>{item.value} - {item.label}</Text>
                                ))}
                            </View>
                            <Text style={styles.commentBody}>{soilComment}</Text>
                            </View>
                    </View>
        
                </Page>
    )
}

const GuidePdf = ({ guide }) => {
    if (!guide) {
        return null;
    }
    // if empty object
    if (Object.keys(guide).length === 0) {
        return null;
    }

    
    return (
        // <PDFViewer>
            <Document>
                <StagePage
                    commonName={guide.commonName}
                    scientificName={guide.scientificName}
                    name={guide.stage}
                    stage={guide.stage1}
                    yearlyChartComment={guide.yearlyChartComment}
                    soilComposition={guide.soilComposition}
                    soilComment={guide.soilComment}
                />
                
                {/* <StagePage
                    commonName={guide.commonName}
                    scientificName={guide.scientificName}
                    name={"Structural"}
                    stage={guide.stage2}
                />
                <StagePage
                    commonName={guide.commonName}
                    scientificName={guide.scientificName}
                    name={"Refinement"}
                    stage={guide.stage3}
                    /> */}
                
            </Document>
    );
}

export default GuidePdf;


{/* <Page
                orientation='landscape'
                style={styles.page}
                
                >
                    <Text style={styles.title}>{guide.commonName}</Text>
                    <Text style={styles.subtitle}>{guide.scientificName}</Text>
                    <View style={styles.table}>
                        <View style={[styles.row, styles.bold, styles.header]}>
                        <Text key={`1st pad`} style={styles.col1}>
                        </Text>
                            {months.map((month) => (
                                <Fragment>
                                <Text key={month} style={styles.monthCell}>
                                    {month}
                                </Text>
                                </Fragment>
                            ))}
                        </View>
                        {guide.stage1.map((row, i) => (
                            <View key={i} style={styles.row} wrap={false}>
                            <Text style={styles.col1}>
                            {row.name}
                            </Text>
                            
                  {numbers.map((number) => (
                            <Text
                            style={[
                                row.decans.includes(number)
                                ? styles.cellTrue
                                : styles.cellFalse,
                                number % 3 === 0 ? styles.thirdCell : null
                            ]
                            }
                            >
                            </Text>
                    ))}
                            
                            </View>
                        ))}
                    </View>

                    
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Comments</Text>
                    {guide.stage1.map((row, i) => (
                        // if there is a comment show the name and comment
                        row.comment &&
                        (<Fragment key={i}>
                            <Text style={styles.commentTitle}>
                                {row.name}
                            </Text>
                            <Text style={styles.commentBody}>
                                {row.comment}
                            </Text>
                        </Fragment>)
                        // comment in each row
                        
                    ))}
                    
                    </View>
                </Page> */}
